import { render, staticRenderFns } from "./conversation-dialog.vue?vue&type=template&id=1431fca8&"
import script from "./conversation-dialog.vue?vue&type=script&lang=js&"
export * from "./conversation-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports